import React, { useEffect, useState } from 'react';
import { Table,  Button, FormGroup, Label, Container, Spinner, Card, CardBody } from 'reactstrap';
import Swal from 'sweetalert2';
import './ManageCriteria.css';
import { FaSave } from "react-icons/fa";
import Select from 'react-select';

export function ManageCriteriaComponent() {
  const user = JSON.parse(localStorage.getItem("userData"))
  const [registerTypes, setRegisterTypes] = useState([]);
  const [supportTypes, setSupportTypes] = useState([]);
  const [selectedRegister, setSelectedRegister] = useState(null);
  const [accessMap, setAccessMap] = useState({});
  const [loading, setLoading] = useState(false);

  const getRegisterTypes = async () => {
    const res = await fetch("/api/ManageSupportCriteria/mdRegisterType");
    const resJson = await res.json();
    setRegisterTypes(resJson.dataenum);
  };

  const getSupportTypes = async () => {
    const res = await fetch("/api/ManageSupportCriteria/mdSupportType");
    const resJson = await res.json();
    setSupportTypes(resJson.dataenum);
  };

  const registerOptions = registerTypes?.map(r => ({
    value: r.registerTypeId,
    label: r.registerTypeName
  }));

  const preloadAccess = async (registerTypeId) => {
    const res = await fetch("/api/ManageSupportCriteria/listCriteria", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: user.token
      }
    });
    const resJson = await res.json();
    const filtered = resJson.dataenum.filter(item => item.registerTypeId === registerTypeId);
    const map = {};
    filtered.forEach(item => {
      map[item.supportTypeId] = {
        supportCriteriaAccessId: item.supportCriteriaAccessId,
        supportCriteriaId: item.supportCriteriaId,
        canAccess: item.canAccess === "Y"
      };
    });
    setAccessMap(map);
  };

  useEffect(() => {
    getRegisterTypes();
    getSupportTypes();
  }, []);

  useEffect(() => {
    if (selectedRegister) preloadAccess(selectedRegister);
    else setAccessMap({});
  }, [selectedRegister]);


  const toggleAccess = (supportTypeId) => {
    setAccessMap((prev) => {
      const prevAccess = prev[supportTypeId] || {};
      return {
        ...prev,
        [supportTypeId]: {
          ...prevAccess,
          canAccess: !prevAccess.canAccess
        }
      };
    });
  };

  const handleSave = async () => {
    if (!selectedRegister) {
      Swal.fire("กรุณาเลือกประเภทผู้ใช้งาน", "", "warning");
      return;
    }
    setLoading(true);
    const foundCriteria = Object.values(accessMap).find(a => a.supportCriteriaId && a.supportCriteriaId !== "0");
    const realCriteriaId = foundCriteria?.supportCriteriaId || "";
    const payload = {
      supportCriteriaId: realCriteriaId,
      registerTypeId: selectedRegister,
      criteriaDetail: supportTypes.map((type) => {
        const access = accessMap[type.supportTypeId] || {};
        return {
          supportCriteriaAccessId: access.supportCriteriaAccessId || "",
          supportCriteriaId: access.supportCriteriaId || "0",
          supportTypeId: type.supportTypeId,
          supportTypeName: type.supportTypeName,
          canAccess: access.canAccess ? "Y" : "N"
        };
      })
    };

    try {
      const res = await fetch("/api/ManageSupportCriteria/createAndUpdateCriteria", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: user.token
        },
        body: JSON.stringify(payload)
      });
      const resJson = await res.json();
      if (resJson.status == "1") {
        Swal.fire("สำเร็จ", "บันทึกสิทธิ์สำเร็จ", "success");
        preloadAccess(selectedRegister);
      } else {
        Swal.fire("ไม่สำเร็จ", resJson.message, "error");
      }
    } catch (err) {
      Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถบันทึกได้", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-4 mb-5 fadeInUp">
      <Card className="card-modern">
        <CardBody>
          <FormGroup>
            <Label for="registerType">ประเภทผู้ใช้งาน</Label>
            <Select
              id="registerType"
              options={registerOptions}
              onChange={(selected) => setSelectedRegister(selected?.value || null)}
              placeholder="-- เลือก --"
              isClearable
              className="react-select-container"
              classNamePrefix="react-select"
            />
            {/* <Input
              type="select"
              id="registerType"
              onChange={(e) => setSelectedRegister(Number(e.target.value))}
            >
              <option value="">-- เลือก --</option>
              {registerTypes.map((r) => (
                <option key={r.registerTypeId} value={r.registerTypeId}>
                  {r.registerTypeName}
                </option>
              ))}
            </Input> */}
          </FormGroup>

          {selectedRegister ? (
            <>
              <div className="table-responsive mt-4">
                <Table bordered className="table-modern align-middle">
                  <thead>
                    <tr>
                      <th className='text-center'>ชื่อแบบฟอร์ม</th>
                      <th className="text-center">สามารถเข้าถึง</th>
                    </tr>
                  </thead>
                  <tbody>
                    {supportTypes.map((form) => {
                      const access = accessMap[form.supportTypeId] || {};
                      return (
                        <tr key={form.supportTypeId}>
                          <td>{form.supportTypeName}</td>
                          <td className="text-center">
                            <label className="d-flex align-items-center gap-2 justify-content-center">
                              <label className="switch-modern">
                                <input
                                  type="checkbox"
                                  checked={!!access.canAccess}
                                  onChange={() => toggleAccess(form.supportTypeId)}
                                />
                                <span className="slider-modern" />
                              </label>
                              {/* <span className="text-muted small me-2">
                                {!!access.canAccess ? "เปิด" : "ปิด"}
                              </span> */}
                            </label>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              <div className="text-center">
                <Button
                  className="btn-modern-save rounded-pill"
                  onClick={handleSave}
                  disabled={loading}
                >
                  {loading ? (
                    <Spinner size="sm" />
                  ) : (
                    <>
                      <FaSave className="me-2" />
                      บันทึกสิทธิ์
                    </>
                  )}
                </Button>
              </div>
            </>
          ) : null}
        </CardBody>
      </Card>
    </Container>
  );
}
